import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Decimation,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Legend,
  Tooltip,
} from "chart.js";

ChartJS.register(
  Decimation,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Legend,
  Tooltip
);

const LineChart = (props) => {
  // Define the data for the line chart
  const data = {
    labels: Array.isArray(props.labels)
      ? props.labels
      : Array.from({ length: props.labels }, (_, index) => index + 1),
    datasets: [
      {
        label: "Left Foot", // Label for the dataset
        data: props.leftData, //Data points for the line
        borderColor: "#165BAA", // Line color
        backgroundColor: "#165BAA", // Fill color below the line
        tension: props.tension ? props.tension : 0, // Curviness of the line
      },
      {
        label: "Right Foot",
        data: props.rightData,
        borderColor: "#A155B9",
        backgroundColor: "#A155B9",
        tension: props.tension ? props.tension : 0,
      },
    ],
  };

  // Define chart options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    devicePixelRatio: window.devicePixelRatio || 1,
    animation: false,
    elements: { point: { radius: 0 } }, // 👈 hide markers
    interaction: { mode: "index", intersect: false },
    scales: {
      x: {
        beginAtZero: false,
        ticks: {
          color: "#165BAA",
          maxTicksLimit: 8,
          // stepSize: 10,
          // size: 14,
          // weight: "bold",
          // family: "Poppins",
        },
      },
      y: {
        beginAtZero: false,
        min: 50,
        ticks: {
          stepSize: 25,
          maxTicksLimit: 6,
        },
      },
    },
    plugins: {
      decimation: {
        enabled: true,
        //algorithm: 'lttb', // 'min-max' is another option
        algorithm: "min-max",
        samples: 300, // Number of data points to display
      },
      legend: { display: true },
      tooltip: { mode: "index", intersect: false },
    },
  };

  return <Line data={data} options={options} height={400} />;
};

export default LineChart;
